// extracted by mini-css-extract-plugin
export var banner = "_1g-0";
export var icon = "_1g-1";
export var message = "_1g-2";